/**
 *
 * Form
 *
 */

import styled from 'styled-components';

const Form =  styled.form`
    margin: 0;
`;

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form/index.js